import React, {useState} from "react";
import {ComplianceCheckInPackage, ProviderType} from "../../../__generated__/graphql/types";
import {ComplianceManagerTab} from "./state";

export type CmContextData = ({ paxNodeId: string } | { checkInPackage: ComplianceCheckInPackage }) &
{
    drawerOpen: boolean,
    defaultProviderTab?: ComplianceManagerTab
}

export interface CmContextFunctions {
    open: (arg1: string | ComplianceCheckInPackage, defaultProviderTab?: ComplianceManagerTab) => void,
    close: () => void
}

export type CmContextValue = CmContextData & CmContextFunctions

const DefaultData = {
    paxNodeId: null,
    drawerOpen: false,
    defaultProviderType: null,
}

export const CMContext = React.createContext<CmContextValue>(null);

/**
 * Allows deeply nested components to control the visibility of the compliance-manager if it is wrapped in a drawer.
 * @constructor
 */
const ComplianceManagerContextProvider: React.FC = (props) => {

    const [ state, setState ] = useState<CmContextData>(DefaultData);

    const open = React.useCallback((arg1: string | ComplianceCheckInPackage, defaultProviderTab?: ComplianceManagerTab) => {
        if (typeof arg1 !== 'string'){
            return setState((s) => ({ ...s, drawerOpen: true, checkInPackage: arg1, defaultProviderTab }));
        }

        const paxNodeId = arg1;
        setState((s) => ({ ...s, drawerOpen: true, paxNodeId, defaultProviderTab }));
    }, [state]);

    const close = React.useCallback(() => {
        setState((s) => ({ ...s, drawerOpen: false, defaultProviderType: null }));
    }, [state]);

    const value = React.useMemo(() => {
        return {
            ...state,
            open: open,
            close: close
        }
    }, [state]);

    return (
        <CMContext.Provider value={value}>
            {props.children}
        </CMContext.Provider>
    )
}

export default ComplianceManagerContextProvider;